import { render, staticRenderFns } from "./GameGroups-Single.vue?vue&type=template&id=2a1a891a&scoped=true"
import script from "./GameGroups-Single.js?vue&type=script&lang=js&external"
export * from "./GameGroups-Single.js?vue&type=script&lang=js&external"
import style0 from "./GameGroups-Single.vue?vue&type=style&index=0&id=2a1a891a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1a891a",
  null
  
)

export default component.exports